<template>
    <v-dialog-old @hidden="cancel" :onCloseEsc="closeModal" ref="connectWithCrmDialog" class="glue" :special-styles="{ width: '1800px' }">
        <v-dialog-old @hidden="closeModal" :onCloseEsc="closeModal" ref="successDialog" class="glue">
            <strong>Связано {{ handled }} из {{ total }}</strong>
            <div v-if="error">
                Последняя ошибка: {{ error }}
            </div>
            <footer>
                <button @click="closeModal" class="green btn-norm" type="submit">OK</button>
            </footer>
        </v-dialog-old>

        <fieldset>
            <legend>
                <span>Связать с CRM</span>
            </legend>

            <label>URLs с разделителями: пробел, перенос или запятая</label>

            <textarea v-model="urls"/>

            <button @click.prevent="submit" :disabled="processing">
                <span v-if="!processing">Связать</span>
                <span v-else>обработка...</span>
            </button>
        </fieldset>
    </v-dialog-old>
</template>

<script>
    export default {
        data: () => ({
            urls: '',
            total: 0,
            handled: 0,
            error: '',
            processing: false,
        }),
        methods: {
            show() {
                this.$refs.connectWithCrmDialog.show()
            },
            cancel() {
                this.urls = '';
                this.handled = 0;
                this.total = 0;
                this.error = '';
            },
            closeModal() {
                this.cancel()
                this.$refs.connectWithCrmDialog.hide()
            },
            submit() {
                if (!this.urls) {
                    return;
                }

                this.processing = true;
                this.axios.post('/admin/settings/tools/connectWithCrm', {
                    urls: this.urls,
                }).then((response) => {
                    this.total = response.data.total;
                    this.handled = response.data.handled;
                    this.error = response.data.error;
                    this.$refs.successDialog.show();
                    this.processing = false;
                }).catch((error) => {
                    this.processing = false;
                })
            },
        },
    }
</script>
